<template>
<div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
   
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Edit Student Misc Fee Receipts</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <span v-if="edit_fee_receipt!=null">
                 <!-- {{edit_fee_receipt}}   -->
                <br />
                <!-- { "standard": "II", "payment_mode": "Online", "receipt_no": "M21-1719", 
                "ammount_paid": 230, "remaining_amount": 0, "stud_name": "Savni Shivkumar Badave", 
                "remark": "Paytm", "prn_no": "1000002568", "paidon": "2021-08-17", "division": "A", "srno": 1,
                 "ammount_to_collected": 230, "ay": 4, "id": 1741, "exam_name": "National Cyber Olympiad (Computer)-Regn & book" } -->
                <v-row justify="center" dense>
                     <v-col cols="12" sm="3" md="3">
                        <v-text-field dense outlined rounded v-model="edit_fee_receipt.receipt_no" persistent-hint label="Edit Receipt No."></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field type="number" dense outlined rounded v-model="edit_fee_receipt.ammount_paid" persistent-hint label="Edit Paid Amount"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field dense outlined rounded v-model="edit_fee_receipt.remark" persistent-hint label="Edit Remark"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete dense outlined rounded item-value="name" item-text="name" :items="payment_mode_list" v-model="edit_fee_receipt.payment_mode" label="Edit Payment Mode"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <input id="datePickerId" type="date" v-model="edit_fee_receipt.paidon" />
                    </v-col>
                </v-row>
            </span>
            <v-row justify="center" dense>
                <v-btn class="button mt-3" @click="editFeeReceipt()">Save</v-btn>
            </v-row>
        </v-card>
</div>
</template>
<script>
    import axios from "axios";
    export default {
        props: ['payment_mode_list','dialog_edit_fee'],
        // {
        //     payment_mode_list: String,
        //     dialog_edit_fee:Boolean
        // },
        data: () => ({
            edit_fee_receipt: null,
             snackbar_msg: "",
            color: "",
            snackbar: false,
        }),

        mounted() {
            this.edit_fee_receipt = this.$store.getters.receipt_data;
        },
        methods: {
             showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editFeeReceipt() {
                const formData = {
                    edit_fee_receipt: this.edit_fee_receipt,
                };
                axios
                    .post("/AccountingAndFeesReports/editMiscFeeReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Student Fee Receipt edited successfully");
                           // this.dialog_edit_fee = false
                            this.$emit('changedialog',false);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
</style>
